import React, {FC, useState} from "react";
import {Alert, Badge, Card, Col, Container, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import axios from "axios";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AuthProvider";

type ExamSelectComponentProps = Record<string, unknown>

const ExamSelectComponent: FC<ExamSelectComponentProps> = () => {
    const {t, i18n} = useTranslation("exam");
    const nav = useNavigate()
    const auth = useAuth();

    const [exams, setExams] = useState<Array<any>>([])

    React.useEffect(() => {
        axios.get("/api/exam/bookable", auth.axiosAuthHeader()).then((response) => {
            setExams(response.data);
        });
    }, []);

    return (<div className="component">
        <Container>
            <Row>
                <Col>
                    <Card className="mt-3">
                        <Card.Header>
                            <h2><i className="bi-ui-checks"></i> {t('examSelect.title')}</h2>
                        </Card.Header>
                        <Card.Body>
                            {exams ? exams.map(exam => (<Row className="mb-3" key={exam._id}>
                                <Col>
                                    <Card border={'success'}>
                                        <Card.Body onClick={() => nav("/booking/" + exam._id)}
                                                   style={{cursor: "pointer"}}>
                                            <Row className="d-flex justify-content-around text-success">
                                                <Col xs={1} className="d-flex align-items-center"><h1><i
                                                    className="bi bi-award"></i></h1></Col>
                                                <Col xs={5} md={10}>
                                                    <h4 className="fw-bold">{t('examSelect.exam')}: {i18n.language === "en" ? exam.name_en || exam.name_de : exam.name_de}</h4>
                                                    {(exam.tucanIds?.length > 0 || exam.hasDisabilityAccommodation) && (
                                                        <p className="d-flex flex-wrap gap-2">
                                                            {exam.tucanIds?.length > 0 && (
                                                                <Badge bg="info">
                                                                    {t('book.exam.tucanhint', {ns: 'booking'})}
                                                                </Badge>
                                                            )}
                                                            {exam.hasDisabilityAccommodation && (
                                                                <Badge bg="success" className="d-inline-flex align-items-center gap-1">
                                                                    <i className="bi bi-universal-access" aria-hidden="true"/>
                                                                    {t('examSelect.disabilityAccommodation')}
                                                                </Badge>
                                                            )}
                                                        </p>
                                                    )}
                                                    <p className="font-monospace">{t('examSelect.booking.from')} <Badge
                                                            bg="secondary"> {moment(exam.openBookingAt).format('LL')}</Badge> {t('examSelect.booking.until')} <Badge
                                                            bg="warning">{moment(exam.closeBookingAt).format('LL')}</Badge>.
                                                        <br/>{t('examSelect.examRange.from')} <Badge
                                                            bg="secondary"> {moment(exam.openExaminationRange).format('LL')}</Badge> {t('examSelect.examRange.until.1')} <Badge
                                                            bg="warning">{moment(exam.closeExaminationRange).format('LL')}</Badge>{t('examSelect.examRange.until.2')}.
                                                    </p>
                                                    <p className="font-monospace">{t('examSelect.briefing.1')} <Badge
                                                        bg="secondary">L4|02 335</Badge> {t('examSelect.briefing.2')} <Badge
                                                        bg="secondary">Lichtwiese</Badge> {t('examSelect.briefing.3')} <Badge
                                                            bg="secondary">20 {t('examSelect.briefing.4')}</Badge> {t('examSelect.briefing.5')} <Badge
                                                            bg={exam.hasDisabilityAccommodation ? "success" : "danger"}
                                                            className="d-inline-flex align-items-center gap-1"
                                                            title={exam.hasDisabilityAccommodation
                                                                ? t("examSelect.disabilityAccommodation")
                                                                : undefined}>
                                                            {exam.hasDisabilityAccommodation && (
                                                                <i className="bi bi-universal-access" aria-hidden="true"/>
                                                            )}
                                                            {exam.duration}
                                                            {Number(exam.disabilityAccommodationMinutes) > 0 && (
                                                                <> + {exam.disabilityAccommodationMinutes}</>
                                                            )}{" "}{t('examSelect.briefing.4')}
                                                        </Badge> {t('examSelect.briefing.6')} <Badge
                                                            bg="secondary">10 {t('examSelect.briefing.4')}</Badge>{t('examSelect.briefing.7')}.
                                                    </p>
                                                </Col>

                                                <Col xs={1} className="d-flex align-items-center"><h1><i
                                                    className="bi bi-arrow-right-circle-fill"></i>
                                                </h1></Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>)) : null}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)

}

export default ExamSelectComponent
